import * as React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"

const Contact = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`

  // if (posts.length === 0) {
  //   return (
  //     <Layout location={location} title={siteTitle}>
  //       <Seo title="All posts" />
  //       <Bio />
  //       <p>
  //         No blog posts found. Add markdown posts to "content/blog" (or the
  //         directory you specified for the "gatsby-source-filesystem" plugin in
  //         gatsby-config.js).
  //       </p>
  //     </Layout>
  //   )
  // }

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="All posts" />

      <section className="spacing-double-extra-large spacing-top-double-extra-large">
        <div className="container">
          <h1 className="spacing-large">Get in touch</h1>
          <h2 className="spacing-medium">Availability</h2>
          <ul className="spacing-medium-large">
            <li className="spacing-small">
              Design consulting and advising for startups
            </li>
            <li>
              Web design and development for local Northwest Arkansas small
              businesses
            </li>
          </ul>

          <h2 className="spacing-medium">Contact information</h2>
          <ul>
            <li className="spacing-small">
              Email:
              <br />
              <strong>Kjartan.Kennedy@gmail.com</strong>
            </li>
            <li>
              Twitter:
              <br />
              <a href="https://www.twitter.com/kjartankennedy">
                <strong>@KjartanKennedy</strong>
              </a>
            </li>
          </ul>
          {/* <div className="spacing-extra-large">
            <h1 className="intro spacing-large">I'm Kjartan —</h1>
            <span className="titles">
              Designer
              <br />
              Builder
              <br />
              Strategist
              <br />
            </span>
          </div>
          <div className="spacing-large">
            <p className="text-large spacing-medium">
              My personal mission is to be a force-multiplier and enabler for
              creative people.
            </p>
            <p className="spacing-medium">
              These days, I’m serving that mission by running Causeway Studios,
              serving on the board of the Game Academy of the Ozarks, and
              designing and building tools for Unity users.
            </p>
            <p>
              I ask difficult questions to facilitate the crafting of great
              experiences.
            </p>
          </div>
          <div>
            <h2 className="spacing-medium">Availability</h2>
            <p className="spacing-medium">
              I’m available to consult on design for startups, helping you
              define your problems and opportunities to craft the right
              solutions.
            </p>
            <button>Get in touch</button>
          </div> */}
        </div>
      </section>

      {/* <Bio /> */}
      {/* <ol style={{ listStyle: `none` }}>
        {posts.map(post => {
          const title = post.frontmatter.title || post.fields.slug

          return (
            <li key={post.fields.slug}>
              <article
                className="post-list-item"
                itemScope
                itemType="http://schema.org/Article"
              >
                <header>
                  <h2>
                    <Link to={post.fields.slug} itemProp="url">
                      <span itemProp="headline">{title}</span>
                    </Link>
                  </h2>
                  <small>{post.frontmatter.date}</small>
                </header>
                <section>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: post.frontmatter.description || post.excerpt,
                    }}
                    itemProp="description"
                  />
                </section>
              </article>
            </li>
          )
        })}
      </ol> */}
    </Layout>
  )
}

export default Contact

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
